// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__fF8QX","menuBtnBurger":"HamburgerMenu_menuBtnBurger__qlLjK","open":"HamburgerMenu_open__imnUB"};